<template>
  <div class="ma-4">
    <v-card>
      <v-data-table
        class="custom-table-tickets ticket-list-table transparent"
        :headers="headers"
        :items="ticketList"
        :options.sync="pagination"
        :server-items-length="totalItems"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 75, 100],
        }"
        :mobile-breakpoint="960"
        :items-per-page="perPage"
        :loading="loading"
        item-key="id"
      >
        <template v-slot:[`item.id`]="{ item }">
          <router-link
            :to="{
              name: 'ticket-details',
              params: { id: item.id },
            }"
            v-track="'ticket-detail-page-link'"
          >
            <span> #{{ item.id }}</span>
          </router-link>
        </template>

        <template v-slot:[`item.subject`]="{ item }">
          <router-link
            :to="{
              name: 'ticket-details',
              params: { id: item.id },
            }"
            v-track="'ticket-detail-page-link'"
          >
            <span v-if="item.subject">
              {{ item.subject | upperCaseFirst }}
            </span>
          </router-link>
        </template>
        <template v-slot:[`item.created_at`]="{ item }">
          {{ item.created_at | formatDate }}
        </template>
        <template v-slot:[`item.group_name`]="{ item }">
          <span v-if="item.group_name">
            {{ item.group_name | upperCaseFirst }}
          </span>
          <span v-else> -- </span>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <span v-if="item.status">
            {{ item.status | upperCaseFirst }}
          </span>
          <span v-else> -- </span>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { $tickets } from "@/services/Index";
export default {
  props: {
    contactId: [Number, String],
  },
  data() {
    return {
      reveal: false,
      headers: [
        {
          text: "Ticket#",
          align: "start",
          sortable: false,
          value: "id",
          width: "50px",
        },
        { text: "Subject", value: "subject", sortable: false },
        {
          text: "Date Created",
          value: "created_at",
          sortable: false,
        },
        // { text: "Group", value: "group_name", sortable: false },

        {
          text: "Status",
          value: "status",
          width: "100px",
          align: "end",
          sortable: false,
        },
      ],
      ticketList: [],
      perPage: 10,
      page: 1,
      totalItems: 0,
      pagination: {},
      loading: false,
    };
  },

  watch: {
    pagination: {
      handler(newVal, oldVal) {
        /** prevent this check to invoked function on page load */
        if (oldVal.itemsPerPage) {
          this.getTicketList();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getTicketList();
  },
  methods: {
    /* Associated tickets for a particular contact */
    async getTicketList() {
      this.loading = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.pagination;
      const data = {
        page,
        per_page: itemsPerPage,
        q: {
          contact_id_in: [this.contactId],
        },
      };
      // If sorting ..
      if (sortBy && sortBy.length) {
        const dir = sortDesc.length
          ? sortDesc[0] === true
            ? "desc"
            : "asc"
          : "";
        data.q.s = `${sortBy[0]} ${dir}`;
      }
      await $tickets
        .fetchList(data, {})
        .then((response) => {
          this.totalItems = response.data.pagination.total_count;
          this.ticketList = response.data.tickets;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
// .custom-table-tickets {
//   table {
//     border-spacing: 2px 25px !important;
//     border-collapse: separate !important;
//     .v-data-table-header tr {
//       background-color: #f0f0f0 !important;
//     }
//     tr {
//       background-color: #fff !important;
//       box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
//         0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%) !important;
//     }
//   }
// }
</style>
